import { useEffect, useState } from "react";
import AppShell from "../components/layout/AppShell";
import Card from "../components/common/Card";
import DataTable from "../components/common/DataTable";
import { listPatients } from "../services/patientService";
import { getDocumentCountAcrossPatients } from "../services/documentService";
import { getPendingRequestsCount } from "../services/accessRequestService";
import { getRecentActivity } from "../services/auditService";
import { getUserCount } from "../services/userService";
import { formatDateTime } from "../utils/format";
import { ACTION_STYLE_MAP } from "../constants/actions";

export default function AdminDashboardPage() {
  const [stats, setStats] = useState({ patients: 0, docs: 0, pending: 0, users: 0 });
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    async function load() {
      const patients = await listPatients(200);
      const patientIds = patients.map((p) => p.id);
      const [docs, pending, users, recent] = await Promise.all([
        getDocumentCountAcrossPatients(patientIds),
        getPendingRequestsCount(),
        getUserCount(),
        getRecentActivity(50),
      ]);
      setStats({ patients: patients.length, docs, pending, users });
      setLogs(recent);
    }
    load();
  }, []);

  return (
    <AppShell title="Admin Panel" pendingCount={stats.pending}>
      <div className="stats-grid">
        <Card>
          <div className="muted">Total Patients</div>
          <div className="h1">{stats.patients}</div>
        </Card>
        <Card>
          <div className="muted">Total Documents</div>
          <div className="h1">{stats.docs}</div>
        </Card>
        <Card>
          <div className="muted">Pending Access Requests</div>
          <div className="h1">{stats.pending}</div>
        </Card>
        <Card>
          <div className="muted">Total Users</div>
          <div className="h1">{stats.users}</div>
        </Card>
      </div>
      <Card style={{ marginTop: 16 }}>
        <h2 className="h2" style={{ marginBottom: 10 }}>
          Recent Activity
        </h2>
        <DataTable
          columns={[
            { key: "timestamp", label: "Timestamp", render: (l) => formatDateTime(l.timestamp) },
            { key: "userName", label: "User" },
            {
              key: "action",
              label: "Action",
              render: (l) => <span className={`badge ${ACTION_STYLE_MAP[l.action] || "badge-standard"}`}>{l.action}</span>,
            },
            { key: "targetType", label: "Target" },
            { key: "targetLabel", label: "Details" },
          ]}
          rows={logs}
          empty={<p className="muted">No activity logs available.</p>}
        />
      </Card>
    </AppShell>
  );
}
